import { round } from './round'

/**
 * Strict percentage calculation.
 * May return NaN if `whole` is 0 or invalid.
 */
export function percentage(part: number, whole: number): number {
	return (part / whole) * 100
}

/**
 * Optimistic percentage calculation.
 * Returns 0 if the result is NaN or if `whole` is 0.
 */
export function optimisticPercentage(part: number, whole: number): number {
	if (whole === 0) return 0 // Avoid division by zero
	const result = (part / whole) * 100
	return Number.isNaN(result) ? 0 : result
}

/**
 * Formats the optimistic percentage with edge case handling.
 * - Returns "< 0.01%" if the percentage is between 0 and 0.01.
 * - Returns "> 99.99%" if the percentage is between 99.99 and 100.
 * - Otherwise, returns the rounded percentage with a "%" sign.
 */
export function formatOptimisticPercentage(part: number, whole: number): string {
	const percentage = optimisticPercentage(part, whole)

	if (percentage > 0 && percentage < 0.01) return '< 0.01%'
	if (percentage > 99.99 && percentage < 100) return '> 99.99%'

	return `${round(percentage)}%`
}
